module.exports = __webpack_public_path__ + "assets/webgl/museum.44e5cf0e.glb";